"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _reactReloadPage = _interopRequireDefault(require("@stubhub/react-reload-page"));
var _reactScrollToTop = _interopRequireDefault(require("@stubhub/react-scroll-to-top"));
var _excluded = ["children", "getRoutes", "Layout"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var App = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(App, _Component);
  var _super = _createSuper(App);
  function App(props, ctx) {
    var _this;
    (0, _classCallCheck2["default"])(this, App);
    _this = _super.call(this, props, ctx);
    var _this$props = _this.props,
      children = _this$props.children,
      getRoutes = _this$props.getRoutes,
      Layout = _this$props.Layout,
      rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
    var routes = typeof getRoutes === 'function' && getRoutes(rest) || [];
    _this.routes = routes;
    _this._props = rest;
    _this.matchRoutes = function (path) {
      return routes.some(function (route) {
        return (0, _reactRouterDom.matchPath)(path, route.props);
      });
    };
    return _this;
  }
  (0, _createClass2["default"])(App, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        matchRoutes: this.matchRoutes
      };
    }
  }, {
    key: "render",
    value: function render() {
      var content = /*#__PURE__*/_react["default"].createElement(_reactScrollToTop["default"], null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, this.routes, __CLIENT__ && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "/*",
        component: _reactReloadPage["default"]
      })));
      var Layout = this.props.Layout;
      if (Layout) {
        return /*#__PURE__*/_react["default"].createElement(Layout, this._props, content);
      }
      return content;
    }
  }]);
  return App;
}(_react.Component);
exports["default"] = App;
(0, _defineProperty2["default"])(App, "childContextTypes", {
  matchRoutes: _propTypes["default"].func
});
(0, _defineProperty2["default"])(App, "propTypes", {
  Layout: _propTypes["default"].elementType,
  getRoutes: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].any
});